import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { Cadastro } from 'src/app/service/classes/cadastro/cadastro';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert';
import { SiopeService } from './siope.service';
import { LocalStorage } from 'src/app/service/classes/localstorage/LocalStorage';
import { Crypto } from 'src/app/service/classes/crypto/crypto';
import { Router } from '@angular/router';
import { Vinculo } from 'src/app/service/classes/cadastro/vinculo';
declare var bootstrap: any;

@Component({
  selector: 'app-siope',
  templateUrl: './siope.component.html',
  styleUrls: ['./siope.component.css'],
})
export class SiopeComponent {
  localStorage: LocalStorage;
  formColaborador: FormGroup;
  formCadastro: FormGroup;
  matricula: any;
  numeroOrdem: string;
  empfil: string;
  colaborador: Cadastro = null;
  loading: boolean = false;

  qualificacoesExistentes: any[] = [];

  listaSeguimentos: any[] = [];
  listaVinculos: any[] = [];
  listaTipoCategoria: any[] = [];
  listaCategoria: any[] = [];
  listaTipoQualificacao: any[] = [];
  listaLocalizacao: any[] = [];
  listaQualificacoes: any[] = [];

  dadosColaborador: any = null;

  tipoQualificacao1Descricao: string;
  tipoQualificacao2Descricao: string;
  tipoQualificacao1Lista: any[] = [];
  tipoQualificacao2Lista: any[] = [];

  qualificacoesForm: FormGroup;
  qualificacoes: any[] = [];
  respostasQualificacoes: any = {};

  qualificacoesFUNDEB1: any[] = [];
  qualificacoesFUNDEB2: any[] = [];

  categoriaSelecionada: any = null;
  filtroCategoria = '';
  categoriasFiltradas = [];

  localizacaoSelecionada: any = null;
  filtroLocalizacao: string = '';
  localizacoesFiltradas: any[] = [];

  constructor(
    public fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private siopeService: SiopeService,
    private route: Router,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    this.localStorage = this.decryptLocalStorage();
    this.qualificacoesForm = this.fb.group({});

    this.formCadastro = this.fb.group({
      matricula: [''],
      nome: [''],
      vinculo: ['', Validators.required],
      seguimento: ['', Validators.required],
      tipoCategoria: ['', Validators.required],
      categoria: ['', Validators.required],
      localizacao: ['', Validators.required],
      tipoQualificacao: [''],
      qualificacao: [''],
    });

    this.formColaborador = this.fb.group({
      matricula: [''],
      nome: [''],
    });

    const navigation = this.route.getCurrentNavigation();
    if (navigation.extras.state) {
      this.matricula = navigation.extras.state.usuario.matricula;
      this.formColaborador.get('matricula').setValue(this.matricula);
      this.buscarColaboradorMatricula(this.matricula);
    }

    this.carregarDadosIniciais();
  }

  ngOnInit() {
    this.categoriasFiltradas = this.listaCategoria;
    this.localizacoesFiltradas = this.listaLocalizacao;
    this.qualificacoesExistentes = [];
  }

  selecionarResposta(qualificacaoId: number, resposta: boolean, tipoQualificacao: number) {
    const controlName = `qualificacao_${qualificacaoId}`;
    const outrosControlName = `${controlName}_outros`;
    const currentValue = this.qualificacoesForm.get(controlName)?.value;

    if (currentValue === resposta) {
      this.qualificacoesForm.get(controlName)?.setValue(null);
      this.qualificacoesForm.get(outrosControlName)?.disable();
      this.qualificacoesForm.get(outrosControlName)?.setValue('');
    } else {
      if (resposta === true) {
        if (tipoQualificacao === 1) {
          this.qualificacoesFUNDEB2.forEach((q) => {
            const fundeb2Control = `qualificacao_${q.Id}`;
            const fundeb2OutrosControl = `${fundeb2Control}_outros`;

            this.qualificacoesForm.get(fundeb2Control)?.setValue(false);
            this.qualificacoesForm.get(fundeb2OutrosControl)?.disable();
            this.qualificacoesForm.get(fundeb2OutrosControl)?.setValue('');
          });
        } else if (tipoQualificacao === 2) {
          this.qualificacoesFUNDEB1.forEach((q) => {
            const fundeb1Control = `qualificacao_${q.Id}`;
            const fundeb1OutrosControl = `${fundeb1Control}_outros`;

            this.qualificacoesForm.get(fundeb1Control)?.setValue(false);
            this.qualificacoesForm.get(fundeb1OutrosControl)?.disable();
            this.qualificacoesForm.get(fundeb1OutrosControl)?.setValue('');
          });
        }
      }

      this.qualificacoesForm.get(controlName)?.setValue(resposta);

      if (this.qualificacoesForm.get(outrosControlName)) {
        if (resposta) {
          this.qualificacoesForm.get(outrosControlName)?.enable();
        } else {
          this.qualificacoesForm.get(outrosControlName)?.disable();
          this.qualificacoesForm.get(outrosControlName)?.setValue('');
        }
      }
    }

    this.changeDetectorRef.detectChanges();
  }

  filtrarCategorias() {
    const filtro = this.filtroCategoria.toLowerCase();
    this.categoriasFiltradas = this.listaCategoria.filter(
      (cat) => cat.Descricao.toLowerCase().includes(filtro) || cat.Id.toString().includes(filtro)
    );
  }

  selecionarCategoria(cat: any) {
    this.categoriaSelecionada = cat;
    this.formCadastro.get('categoria').setValue(cat.Id);
  }

  filtrarLocalizacoes() {
    const filtro = this.filtroLocalizacao.toLowerCase();
    this.localizacoesFiltradas = this.listaLocalizacao.filter(
      (loc) => loc.Descricao.toLowerCase().includes(filtro) || loc.Id.toString().includes(filtro)
    );
  }

  selecionarLocalizacao(loc: any) {
    this.localizacaoSelecionada = loc;
    this.formCadastro.get('localizacao').setValue(loc.Id);
  }

  decryptLocalStorage(): LocalStorage {
    if (localStorage.getItem('util') != null) {
      return JSON.parse(new Crypto().decryptUsingAES256(localStorage.getItem('util')));
    }
    return new LocalStorage();
  }

  carregarDadosIniciais() {
    this.spinner.show();
    this.buscarSeguimentos();
    this.buscarVinculos();
    this.buscarTiposCategoria();
    this.buscarTiposQualificacao();
    this.buscarQualificacoes();
    this.buscarLocalizacao();

    this.spinner.hide();
  }

  buscarSeguimentos() {
    this.spinner.show();
    this.siopeService.buscarSeguimentos().subscribe((data: any) => {
      this.listaSeguimentos = data;

      this.spinner.hide();
    });
  }

  buscarVinculos() {
    this.spinner.show();
    this.siopeService.buscarVinculos().subscribe((data: any) => {
      this.listaVinculos = data;

      this.spinner.hide();
    });
  }

  buscarTiposCategoria() {
    this.spinner.show();
    this.siopeService.buscarTiposCategoria().subscribe((data: any) => {
      this.listaTipoCategoria = data;

      this.spinner.hide();
    });
  }
  abrirModalCategoria() {
    if (this.listaCategoria.length > 0) {
      const modalElement = document.getElementById('modalCategoria');
      if (modalElement) {
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
      }
    }
  }

  buscarCategoria(IdTipoCategoria: number) {
    this.spinner.show();
    this.siopeService.buscarCategoria(IdTipoCategoria).subscribe({
      next: (data: any) => {
        this.listaCategoria = data || [];
        this.categoriasFiltradas = [...this.listaCategoria];

        if (this.categoriaSelecionada) {
          setTimeout(() => {
            const categoria = this.listaCategoria.find(
              (c) => c.Id === this.categoriaSelecionada.Id
            );
            if (categoria) {
              this.categoriaSelecionada = categoria;
            }
          }, 300);
        }

        this.spinner.hide();
      },
    });
  }

  buscarQualificacoes() {
    this.spinner.show();
    this.siopeService.buscarQualificacoes().subscribe((data: any) => {
      this.listaQualificacoes = data;
      this.qualificacoesFUNDEB1 = data.filter((q: any) => q.IdTipoQualificacao === 1);
      this.qualificacoesFUNDEB2 = data.filter((q: any) => q.IdTipoQualificacao === 2);

      data.forEach((item: any) => {
        this.qualificacoesForm.addControl(`qualificacao_${item.Id}`, this.fb.control(false));

        if (item.Outros === 'S') {
          this.qualificacoesForm.addControl(
            `qualificacao_${item.Id}_outros`,
            this.fb.control({ value: '', disabled: true })
          );
        }
      });

      this.spinner.hide();
    });
  }
  deveMostrarCampoOutros(qualificacaoId: number): boolean {
    const controle = this.qualificacoesForm.get(`qualificacao_${qualificacaoId}_checkbox`);
    return controle ? controle.value : false;
  }

  getRespostasQualificacoes() {
    const respostas: any[] = [];

    this.qualificacoes.forEach((qualificacao) => {
      if (qualificacao.Outros === 'S') {
        respostas.push({
          Id: qualificacao.Id,
          Pergunta: qualificacao.Descricao,
          Resposta: this.qualificacoesForm.get(`qualificacao_${qualificacao.Id}_outros`)?.value,
          Tipo: 'texto',
        });
      } else {
        respostas.push({
          Id: qualificacao.Id,
          Pergunta: qualificacao.Descricao,
          Resposta: this.qualificacoesForm.get(`qualificacao_${qualificacao.Id}`)?.value,
          Tipo: 'boolean',
        });
      }
    });

    return respostas;
  }

  buscarTiposQualificacao() {
    this.spinner.show();
    this.siopeService.buscarTiposQualificacao().subscribe((data: any[]) => {
      this.listaTipoQualificacao = data;

      this.tipoQualificacao1Lista = data.filter((item) => item.Id === 1);
      this.tipoQualificacao2Lista = data.filter((item) => item.Id === 2);

      this.tipoQualificacao1Descricao = this.tipoQualificacao1Lista[0]?.Descricao || '';
      this.tipoQualificacao2Descricao = this.tipoQualificacao2Lista[0]?.Descricao || '';

      this.spinner.hide();
    });
  }

  buscarLocalizacao() {
    this.spinner.show();
    this.siopeService.buscarLocalizacao().subscribe((data: any) => {
      this.listaLocalizacao = data;

      this.spinner.hide();
    });
  }

  buscarColaboradorMatricula(matricula) {
    this.limparFormularioQualificacoes();

    this.spinner.show();
    this.siopeService.buscarColaboradorMatricula(matricula).subscribe((data: Cadastro) => {
      this.numeroOrdem = data.NumeroDeOrdem;
      this.empfil = data.Filial.Codigo;
      this.setarFormColaborador(data);
      this.colaborador = data;

      this.buscarColaboradorSiope();
      this.buscarQualificacaoSiope();

      this.spinner.hide();
    });
  }

  private limparFormularioQualificacoes() {
    Object.keys(this.qualificacoesForm.controls).forEach((controlName) => {
      const control = this.qualificacoesForm.get(controlName);

      if (controlName.includes('_outros')) {
        control?.disable();
        control?.setValue('');
      } else {
        control?.setValue(false);
      }
    });

    this.qualificacoesExistentes = [];
  }

  buscarQualificacaoSiope() {
    const numeroOrdem = this.numeroOrdem;
    this.spinner.show();
    this.siopeService.buscarQualificacaoSiope(numeroOrdem).subscribe({
      next: (data: any) => {
        if (data && Array.isArray(data)) {
          this.qualificacoesExistentes = data;
          this.preencherQualificacoes();
        }
        this.spinner.hide();
      },
    });
  }

  buscarColaboradorSiope() {
    const numeroOrdem = this.numeroOrdem;
    this.spinner.show();
    this.siopeService.buscarColaboradorSiope(numeroOrdem).subscribe({
      next: (data: any) => {
        const hasValidData =
          data &&
          (data.IdCategoria !== 0 ||
            data.IdVinculo !== 0 ||
            data.IdSeguimento !== 0 ||
            data.OutrosFundeb70 !== null ||
            data.OutrosFundeb30 !== null);

        if (hasValidData) {
          this.dadosColaborador = data;

          this.formCadastro.patchValue({
            vinculo: data.IdVinculo !== 0 ? data.IdVinculo : '',
            seguimento: data.IdSeguimento !== 0 ? data.IdSeguimento : '',
            categoria: data.IdCategoria !== 0 ? data.IdCategoria : '',
            localizacao: data.IdLocalizacao !== 0 ? data.IdLocalizacao : '',
          });

          if (data.Categoria && data.Categoria.Id !== 0) {
            this.categoriaSelecionada = data.Categoria;
            this.formCadastro.get('tipoCategoria').setValue(data.Categoria.IdTipoCategoria);
            this.buscarCategoria(data.Categoria.IdTipoCategoria);
          }

          if (data.Localizacao && data.Localizacao.Id !== 0) {
            this.localizacaoSelecionada = data.Localizacao;
          }

          if (data.OutrosFundeb70 || data.OutrosFundeb30) {
            this.preencherCamposOutros(data.OutrosFundeb70, data.OutrosFundeb30);
          }

          this.preencherQualificacoes();
        } else {
          this.dadosColaborador = null;

          this.formCadastro.patchValue({
            tipoCategoria: '',
            vinculo: '',
            seguimento: '',
            categoria: '',
            localizacao: '',
          });
          this.categoriaSelecionada = null;
          this.localizacaoSelecionada = null;
        }
        this.spinner.hide();
      },
      error: (error) => {
        this.spinner.hide();
        if (error.status === 404) {
          this.dadosColaborador = null;
          this.formCadastro.patchValue({
            vinculo: '',
            seguimento: '',
            categoria: '',
            localizacao: '',
          });
          this.categoriaSelecionada = null;
          this.localizacaoSelecionada = null;
        }
      },
    });
  }

  preencherQualificacoes() {
    this.spinner.show();

    this.siopeService.buscarQualificacaoSiope(this.numeroOrdem).subscribe({
      next: (response: any[]) => {
        try {
          const qualificacoes = Array.isArray(response) ? response : [];

          qualificacoes.forEach((q) => {
            const controlName = `qualificacao_${q.IdQualificacao}`;

            if (this.qualificacoesForm.get(controlName)) {
              const valorResposta = q.Resultado === 'S';
              this.qualificacoesForm.get(controlName).setValue(valorResposta);

              const outrosControlName = `${controlName}_outros`;
              if (this.qualificacoesForm.get(outrosControlName)) {
                const qualificacao = this.listaQualificacoes.find(
                  (item) => item.Id === q.IdQualificacao
                );

                if (qualificacao?.Outros === 'S') {
                  if (valorResposta) {
                    this.qualificacoesForm.get(outrosControlName).enable();
                  } else {
                    this.qualificacoesForm.get(outrosControlName).disable();
                    this.qualificacoesForm.get(outrosControlName).setValue('');
                  }
                }
              }
            }
          });
        } catch (e) {
          console.error('Erro ao processar qualificações:', e);
        }
        this.spinner.hide();
      },
    });
  }

  preencherCamposOutros(outrosFundeb70: string, outrosFundeb30: string) {
    const qualificacaoOutros70 = this.qualificacoesFUNDEB1.find((q) => q.Outros === 'S');
    const qualificacaoOutros30 = this.qualificacoesFUNDEB2.find((q) => q.Outros === 'S');

    if (qualificacaoOutros70 && outrosFundeb70) {
      const controlName = `qualificacao_${qualificacaoOutros70.Id}_outros`;
      if (this.qualificacoesForm.get(controlName)) {
        this.qualificacoesForm.get(controlName).setValue(outrosFundeb70);
        this.qualificacoesForm.get(controlName).enable();

        this.qualificacoesForm.get(`qualificacao_${qualificacaoOutros70.Id}`).setValue(true);
      }
    }

    if (qualificacaoOutros30 && outrosFundeb30) {
      const controlName = `qualificacao_${qualificacaoOutros30.Id}_outros`;
      if (this.qualificacoesForm.get(controlName)) {
        this.qualificacoesForm.get(controlName).setValue(outrosFundeb30);
        this.qualificacoesForm.get(controlName).enable();

        this.qualificacoesForm.get(`qualificacao_${qualificacaoOutros30.Id}`).setValue(true);
      }
    }
  }

  onTipoCategoriaChange() {
    if (!this.formCadastro) {
      console.error('Formulário não inicializado');
      return;
    }

    const idTipo = this.formCadastro.get('tipoCategoria')?.value;
    if (idTipo) {
      this.buscarCategoria(idTipo);
    } else {
      this.listaCategoria = [];
      this.categoriasFiltradas = [];
      this.formCadastro.get('categoria').reset();
      this.categoriaSelecionada = null;
    }
  }

  matriculaListener(evento) {
    this.matricula = evento.Matricula;
    this.buscarColaboradorMatricula(this.matricula);
  }

  setarFormColaborador(data) {
    this.formColaborador.get('matricula').disable();
    this.formColaborador.get('matricula').setValue(this.matricula);
    this.formColaborador.get('nome').disable();
    this.formColaborador.get('nome').setValue(data.InformacoesBasicas.NomeCompleto);
    this.loading = false;
  }

  retornarTelaInicial() {
    this.matricula = null;
    this.formColaborador.reset();
    this.formColaborador.markAsPristine();
    this.formColaborador.get('matricula').enable();
  }

  private scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement = document.querySelector(
      'form .ng-invalid, form [class*="is-invalid"]'
    );

    if (firstInvalidControl) {
      firstInvalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' });

      if (
        firstInvalidControl instanceof HTMLInputElement ||
        firstInvalidControl instanceof HTMLSelectElement ||
        firstInvalidControl instanceof HTMLTextAreaElement
      ) {
        firstInvalidControl.focus();
      }
    }
  }

  onSubmit() {
    Object.keys(this.formCadastro.controls).forEach((field) => {
      const control = this.formCadastro.get(field);
      control.markAsTouched({ onlySelf: true });
    });

    const hasInvalidOutrosFields = this.checkInvalidOutrosFields();

    if (
      this.formColaborador.invalid ||
      this.formCadastro.invalid ||
      this.qualificacoesForm.invalid ||
      hasInvalidOutrosFields
    ) {
      Swal('Atenção', 'Preencha todos os campos obrigatórios', 'warning');
      this.scrollToFirstInvalidControl();
      return;
    }

    this.spinner.show();

    const dadosColaborador = {
      NumeroOrdem: this.numeroOrdem,
      IdLocalizacao: this.formCadastro.get('localizacao').value,
      IdCategoria: this.formCadastro.get('categoria').value,
      IdVinculo: this.formCadastro.get('vinculo').value,
      IdSeguimento: this.formCadastro.get('seguimento').value,
      OutrosFundeb70: this.getOutrosFundeb70(),
      OutrosFundeb30: this.getOutrosFundeb30(),
    };

    if (
      this.dadosColaborador &&
      (this.dadosColaborador.IdCategoria !== 0 ||
        this.dadosColaborador.IdVinculo !== 0 ||
        this.dadosColaborador.IdSeguimento !== 0)
    ) {
      this.atualizarDadosColaborador(dadosColaborador);
      this.spinner.hide();
    } else {
      this.cadastrarDadosColaborador(dadosColaborador);
      this.spinner.hide();
    }
  }

  checkInvalidOutrosFields(): boolean {
    let hasError = false;

    [...this.qualificacoesFUNDEB1, ...this.qualificacoesFUNDEB2]
      .filter((q) => q.Outros === 'S')
      .forEach((q) => {
        const resposta = this.qualificacoesForm.get(`qualificacao_${q.Id}`)?.value;
        const outrosTexto = this.qualificacoesForm.get(`qualificacao_${q.Id}_outros`)?.value;

        if (resposta === true && (!outrosTexto || outrosTexto.trim() === '')) {
          this.qualificacoesForm.get(`qualificacao_${q.Id}_outros`)?.setErrors({ required: true });
          hasError = true;
        } else {
          this.qualificacoesForm.get(`qualificacao_${q.Id}_outros`)?.setErrors(null);
        }
      });

    return hasError;
  }

  getOutrosFundeb70(): string {
    const qualificacaoOutros = this.qualificacoesFUNDEB1.find((q) => q.Outros === 'S');
    if (qualificacaoOutros) {
      return (
        this.qualificacoesForm.get(`qualificacao_${qualificacaoOutros.Id}_outros`)?.value || ''
      );
    }
    return '';
  }

  getOutrosFundeb30(): string {
    const qualificacaoOutros = this.qualificacoesFUNDEB2.find((q) => q.Outros === 'S');
    if (qualificacaoOutros) {
      return (
        this.qualificacoesForm.get(`qualificacao_${qualificacaoOutros.Id}_outros`)?.value || ''
      );
    }
    return '';
  }

  cadastrarDadosColaborador(dados: any) {
    console.log('Enviando POST para cadastrar:', dados);
    this.siopeService.cadastrarDadosColaborador(dados).subscribe({
      next: (response) => {
        this.dadosColaborador = response;
        this.enviarQualificacoes();
        this.spinner.hide();
        Swal('Sucesso', 'Dados cadastrados com sucesso!', 'success');
      },
    });
  }

  atualizarDadosColaborador(dados: any) {
    console.log('Enviando PUT para atualizar:', dados);
    this.siopeService.atualizarDadosColaborador(this.numeroOrdem, dados).subscribe({
      next: (response) => {
        this.dadosColaborador = { ...this.dadosColaborador, ...dados };
        this.enviarQualificacoes();
        this.spinner.hide();
        Swal('Sucesso', 'Dados atualizados com sucesso!', 'success');
      },
    });
  }

  enviarQualificacoes() {
    const hasQualificacoes = this.qualificacoesExistentes?.length > 0;

    const qualificacoesParaEnviar = [
      ...this.qualificacoesFUNDEB1,
      ...this.qualificacoesFUNDEB2,
    ].map((qualificacao) => {
      const resposta = this.qualificacoesForm.get(`qualificacao_${qualificacao.Id}`)?.value;
      return {
        IdQualificacao: qualificacao.Id,
        NumeroOrdem: +this.numeroOrdem,
        Resultado: resposta === null ? '' : resposta ? 'S' : 'N',
      };
    });

    this.spinner.show();

    if (hasQualificacoes) {
      this.siopeService.atualizarQualificacao(this.numeroOrdem, qualificacoesParaEnviar).subscribe({
        next: () => {
          this.spinner.hide();
          Swal('Sucesso', 'Qualificações atualizadas com sucesso!', 'success');
        },
        error: (error) => {
          this.spinner.hide();
          Swal('Erro', 'Erro ao atualizar qualificações', 'error');
        },
      });
    } else {
      this.siopeService.cadastrarQualificacao(qualificacoesParaEnviar).subscribe({
        next: () => {
          this.spinner.hide();
          Swal('Sucesso', 'Qualificações cadastradas com sucesso!', 'success');
          this.buscarQualificacaoSiope();
        },
      });
    }
  }

  hasExistingData(): boolean {
    if (!this.dadosColaborador) return false;

    return (
      this.dadosColaborador.IdCategoria !== 0 ||
      this.dadosColaborador.IdVinculo !== 0 ||
      this.dadosColaborador.IdSeguimento !== 0 ||
      this.dadosColaborador.OutrosFundeb70 !== null ||
      this.dadosColaborador.OutrosFundeb30 !== null
    );
  }
}

export interface Siope {
  Sigla: string;
  Mat: string;
  Empfil: string;
  DataInicio: string;
  DataFim: string;
  TipoCategoria: string;
  Categoria: string;
  TipoQualificacao?: string;
  Qualificacao?: string;
  IdCategoria?: number;
  IdVinculo?: number;
  IdSeguimento?: number;
  OutrosFundeb70?: string;
  OutrosFundeb30?: string;
}
